export const getLocalStorage = (key) => {
    if (!window) {
        return null;
    }

    const item = window.localStorage.getItem(key);

    if (item === undefined || item === null) {
        return null;
    }

    return JSON.parse(item);
};


export const setLocalStorage = (key, obj) => {
    window.localStorage.setItem(key, JSON.stringify(obj));
};

export const isLocalStorageAvailable = () => {
    if (window.localStorage) {
        try {
            window.localStorage.setItem('test', 'test');
            window.localStorage.removeItem('test');

            return true;
        } catch (error) {
            return false;
        }
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// /src/js/common/utils/localStorage.js